module.exports = __webpack_public_path__ + "img/svg/about-us.0e8ddd58379d3d37c359c39516f5c995.svg";